import * as React from "react";

import { Skeleton, SkeletonGenerator, Margins } from "@ui/Atoms";
import { Row, Column, Container } from "@ui/Atoms/Grid";

const AccountCreationPageSkeleton = React.memo(() => (
  <Margins xs={["base_x2", "base_x2", null, null]}>
    <Container>
      <Row>
        <Column>
          <Skeleton shape="row" />
          <SkeletonGenerator
            count={4}
            shape="rectVertical"
            randomHeight={180}
          />
          <Skeleton shape="row" />
        </Column>
      </Row>
    </Container>
  </Margins>
));
AccountCreationPageSkeleton.displayName = "AccountCreationPageSkeleton";

export { AccountCreationPageSkeleton };
